__turbopack_context__.v({
  "className": "body_f73beb1b-module__7JJN2G__className",
  "variable": "body_f73beb1b-module__7JJN2G__variable",
});
